import { render, staticRenderFns } from "./SearchBarResults.vue?vue&type=template&id=b4e47aa6&scoped=true&"
import script from "./SearchBarResults.vue?vue&type=script&lang=js&"
export * from "./SearchBarResults.vue?vue&type=script&lang=js&"
import style0 from "./SearchBarResults.vue?vue&type=style&index=0&id=b4e47aa6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e47aa6",
  null
  
)

export default component.exports